import { parse } from '@/services/languageParser'

export default {
    methods: {
        setLanguage(language) {
            if (language === null) {
                console.error('Language not detected, setting default to en-GB')
                this.setCurrentLanguage('en-GB')
                this.setTranslation(this.$content['en-GB'])
            } else {
                const languages = parse(language)
                switch (languages[0].region) {
                    case 'GB':
                        this.setCurrentLanguage('en-GB')
                        this.setTranslation(this.$content['en-GB'])
                        break
                    case 'US':
                        this.setCurrentLanguage('en-US')
                        this.setTranslation(this.$content['en-US'])
                        break
                    case 'CA':
                        this.setCurrentLanguage('en-CA')
                        this.setTranslation(this.$content['en-CA'])
                        break
                    case 'DK':
                        this.setCurrentLanguage('da-DK')
                        this.setTranslation(this.$content['da-DK'])
                        break
                    case 'DE':
                        this.setCurrentLanguage('de-DE')
                        this.setTranslation(this.$content['de-DE'])
                        break
                    case 'GR':
                        this.setCurrentLanguage('el-GR')
                        this.setTranslation(this.$content['el-GR'])
                        break
                    case 'ES':
                        this.setCurrentLanguage('es-ES')
                        this.setTranslation(this.$content['es-ES'])
                        break
                    case 'FI':
                        this.setCurrentLanguage('fi-FI')
                        this.setTranslation(this.$content['fi-FI'])
                        break
                    case 'HR':
                        this.setCurrentLanguage('hr-HR')
                        this.setTranslation(this.$content['hr-HR'])
                        break
                    case 'NO':
                        this.setCurrentLanguage('nb-NO')
                        this.setTranslation(this.$content['nb-NO'])
                        break
                    case 'NL':
                        this.setCurrentLanguage('nl-NL')
                        this.setTranslation(this.$content['nl-NL'])
                        break
                    case 'SE':
                        this.setCurrentLanguage('sv-SE')
                        this.setTranslation(this.$content['sv-SE'])
                        break
                    case 'FR':
                        this.setCurrentLanguage('fr-FR')
                        this.setTranslation(this.$content['fr-FR'])
                        break
                    default:
                        // Default fallback
                        this.setTranslation(this.$content['en-GB'])
                }
            }
        }
    }
}
